module.exports = __webpack_public_path__ + "img/beaker-clear.20580d76.png";